const Footer = () => {
  return (
    <footer className="bg-gray-100 p-1 text-center text-sm text-xs text-gray-600">
      <div className="flex flex-col items-center justify-center gap-2 sm:flex-row sm:gap-4">
        <span data-testid="copyright">
          © 2026 Regulify Application Window. All rights reserved.
        </span>
        <span className="hidden sm:inline">|</span>
        <a
          href="/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline"
        >
          Privacy Policy
        </a>
        <span className="hidden sm:inline">|</span>
        <a
          href="/service-agreement"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline"
        >
          Terms of Use
        </a>
      </div>
    </footer>
  );
};

export default Footer;
